import React, { Component } from 'react';
import { Grid, withStyles } from '@material-ui/core';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import { API_URL } from '../common/Constants';
import axios from 'axios';

// import TitleText from '../common/TitleText';
// import Table from '@material-ui/core/Table';
// import TableHead from '@material-ui/core/TableHead';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableRow from '@material-ui/core/TableRow';

// const HistoryData = [
//   {
//     year: '1996',
//     date1: '07.06',
//     title1: '(주)두원시스템 설립',
//     desc1: '',
//     date2: '',
//     title2: '',
//     desc2: '',
//     date3: '',
//     title3: '',
//     desc3: '',
//   },
//   {
//     year: '2001',
//     date1: '11',
//     title1: 'ISO9001 품질경영시스템 인증',
//     desc1: '',
//     date2: '04',
//     title2: '신기술개발 벤처기업 인증',
//     desc2: '(서울지방중소기업청 제2001113442-6206호)',
//     date3: '',
//     title3: '',
//     desc3: '',
//   },
//   {
//     year: '2015',
//     date1: '10',
//     title1:
//       '신규사업 런칭 (스탬프투어 통합컨설팅 및 스탬프, 스탬프인증대, 스탬프북, 각종 인쇄물,기념물, 홍보대행, 관광활성화 아이템 개발 등 사업영역 확장)',
//     desc1: '',
//     date2: '',
//     title2: '-중략-',
//     desc2: '',
//     date3: '',
//     title3: '',
//     desc3: '',
//   },
//   {
//     year: '2017',
//     date1: '05.23',
//     title1: '스탬핑 유닛과 이를 갖는 인증 스탬프시스템 개발',
//     desc1: '(특허 출원...1종)',
//     date2: '',
//     title2: '',
//     desc2: '',
//     date3: '',
//     title3: '',
//     desc3: '',
//   },
//   {
//     year: '2018',
//     date1: '12.19',
//     title1: '관광벤처기업 7전8기 부문 수상',
//     desc1: '(한국관광공사 제2018-1166호)',
//     date2: '06.01',
//     title2: '관광벤처기업 선정',
//     desc2: '(문화체육관광부 제2018-15호)',
//     date3: '03.21',
//     title3: '임의날인 방지부를 갖는 스탬프 유닛 개발',
//     desc3: '(특허 출원...7종)',
//   },
//   {
//     year: '2019',
//     date1: '12.11',
//     title1: '특허 획득',
//     desc1: ' (임의날인 방지부를 갖는 스탬핑 유닛_7종)… 제10−2056775호',
//     date2: '02.19',
//     title2: '특허 획득',
//     desc2: '(스탬핑 유닛과 이를 갖는 인증 스탬프시스템_1종)… 제10−1951937호',
//     date3: '',
//     title3: '',
//     desc3: '',
//   },
//   {
//     year: '2020',
//     date1: '10',
//     title1: '2020 한국 온라인 박람회 참가',
//     desc1: ' ',
//     date2: '08',
//     title2: '관광혁신바우처 선정',
//     desc2: '',
//     date3: '',
//     title3: '',
//     desc3: '',
//   },
//   {
//     year: '2021',
//     date1: '02',
//     title1: '온라인 스탬프투어 플랫폼 런칭',
//     desc1: ' ',
//     date2: '01',
//     title2: '인증대 특허출원 ',
//     desc2: '(스프링훼손 방지형 자동도어 닫힘장치 스탬프인증 유닛) 접수번호1-1-2021-0094919-87',
//     date3: '',
//     title3: '',
//     desc3: '',
//   },
// ];

const styles = (theme) => ({
  bg: {
    width: '100%',
    // height: 'calc(100vh - 85px)',
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: '#fafafa',
  },
  yearText: {
    fontSize: '1.5em',
    fontWeight: 'bold',
  },
});

class CompHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      imgData: '',
    };
  }

  componentDidMount() {
    axios
      .get(`${API_URL}/admin/menuInfo`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        // console.log(response.data);
        let _result = response.data;
        this.setState({ imgData: _result });
        // console.log('imgData', this.state.imgData);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    const { classes } = this.props;

    // const mapToComponent = (datas) => {
    //   datas = HistoryData;
    //   // console.log(datas);

    //   return datas.reverse().map((items, i) => {
    //     return (
    //       <Grid container justify="center" key={i}>
    //         <TableContainer>
    //           <Table>
    //             <TableHead>
    //               <TableRow>
    //                 <TableCell
    //                   align="center"
    //                   rowSpan={2}
    //                   width="10%"
    //                   style={{ color: '#1d1b54', fontWeight: 'bold', fontSize: '1.5em', border: 'none' }}
    //                 >
    //                   {items.year}
    //                 </TableCell>
    //                 <TableCell width="90%" style={{ borderBottom: '2px solid #1d1b54' }} />
    //               </TableRow>
    //               <TableRow>
    //                 <TableCell width="10%" style={{ border: 'none' }} />
    //                 <TableCell width="90%" style={{ border: 'none' }} />
    //               </TableRow>
    //             </TableHead>
    //           </Table>
    //         </TableContainer>

    //         <Grid container item xs={10} md={9} justify="center" style={{ wordBreak: 'keep-all' }}>
    //           {(items.date1 === '' && items.title1 === '') || (
    //             <Grid container style={{ padding: '2vh 0', borderBottom: '1px solid #eeeeee' }}>
    //               <Grid container item xs={3} md={2} style={{ color: '#1d1b54', fontWeight: 'bold', fontSize: '1.2em' }}>
    //                 {items.date1}
    //               </Grid>
    //               <Grid container item xs={9} md={10}>
    //                 <Grid container style={{ color: '#555555', fontSize: '1.1em' }}>
    //                   {items.title1}
    //                 </Grid>
    //                 <Grid container style={{ color: '#999999', marginTop: '1vh' }}>
    //                   {items.desc1}
    //                 </Grid>
    //               </Grid>
    //             </Grid>
    //           )}
    //           {(items.date2 === '' && items.title2 === '') || (
    //             <Grid container style={{ padding: '2vh 0', borderBottom: '1px solid #eeeeee' }}>
    //               <Grid container item xs={3} md={2} style={{ color: '#1d1b54', fontWeight: 'bold', fontSize: '1.2em' }}>
    //                 {items.date2}
    //               </Grid>
    //               <Grid container item xs={9} md={10}>
    //                 <Grid container style={{ color: '#555555', fontSize: '1.1em' }}>
    //                   {items.title2}
    //                 </Grid>
    //                 <Grid container style={{ color: '#999999', marginTop: '1vh' }}>
    //                   {items.desc2}
    //                 </Grid>
    //               </Grid>
    //             </Grid>
    //           )}
    //           {(items.date3 === '' && items.title3 === '') || (
    //             <Grid container style={{ padding: '2vh 0', borderBottom: '1px solid #eeeeee' }}>
    //               <Grid container item xs={3} md={2} style={{ color: '#1d1b54', fontWeight: 'bold', fontSize: '1.2em' }}>
    //                 {items.date3}
    //               </Grid>
    //               <Grid container item xs={9} md={10}>
    //                 <Grid container style={{ color: '#555555', fontSize: '1.1em' }}>
    //                   {items.title3}
    //                 </Grid>
    //                 <Grid container style={{ color: '#999999', marginTop: '1vh' }}>
    //                   {items.desc3}
    //                 </Grid>
    //               </Grid>
    //             </Grid>
    //           )}
    //         </Grid>
    //       </Grid>
    //     );
    //   });
    // };
    return (
      <React.Fragment>
        <Topbar />
        <div className={classes.bg}>
          <Grid id="positioning_grid" container justify="center" style={{ padding: '0 30px' }}>
            <Grid container justify="flex-start" style={{ padding: '2vh calc(2vw - 30px)', color: '#1b1d54', fontSize: '1.3em' }}>
              <b>회사소개 〉 회사연혁</b>
            </Grid>
            <Grid container item xs={12} md={6} style={{ backgroundColor: '#ffffff', margin: '4vh 0', borderRadius: '20px' }}>
              {/* <TitleText title="회사연혁" /> */}
              {/* <Grid style={{ width: '100%', padding: '4vh 4vw' }}>{mapToComponent(this.props.data)}</Grid> */}
              <Grid container justify="center" style={{ padding: '4vh 4vw' }}>
                <img
                  src={'/images/compHis@2x.png'}
                  alt={'회사연혁'}
                  style={{ width: '100%', maxHeight: this.state.matches ? '80vh' : '', WebkitTouchCallout: 'none' }}
                  onContextMenu={(e) => e.preventDefault()}
                />
              </Grid>
            </Grid>
          </Grid>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(CompHistory);
